<template>
  <div class="StaffBox">
    <div class="StaffBox-title">
      <div>
        <img class="titleIcon" src="@/assets/images/xinyulou/icon_1.png" alt />
        <span>业务数据总看板</span>
        <el-tooltip
          class="item"
          effect="dark"
          content="默认展示上一个月的数据"
          placement="top"
          size="small"
        >
          <img
            class="tipsIcon"
            src="@/assets/images/xinyulou/tip_icon.png"
            alt
          />
        </el-tooltip>
      </div>

      <div class="StaffBox-right">
        <el-date-picker
          v-model="dateTime"
          type="daterange"
          :picker-options="pickerOptions"
          :editable="false"
          start-placeholder="开始日期"
          range-separator="~"
          end-placeholder="结束日期"
          clearable
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          @change="dataSearch"
        >
        </el-date-picker>
        <img
          class="titleTipIcon"
          src="@/assets/images/xinyulou/tip_icon2.png"
          @click="$emit('tipOpen')"
        />
      </div>
    </div>

    <div class="StaffBox-data" v-loading="dataLoading">
      <div v-for="(item, index) in listData" :key="index">
        <div class="flexCenter">
          <div class="name">{{ item.name }}</div>
          <div class="num">{{ item.num }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
import { _http } from "@/utils/request/storeStatistics";
let postionTime = Date.now();
export default {
  components: {},
  data() {
    return {
      dataLoading: true,
      listData: [
        {
          name: "总回收量（个）",
          num: 0,
          key: "dealCount",
        },
        {
          name: "总回收金额（元）",
          num: 0,
          key: "dealPrice",
        },
        {
          name: "总事业部返佣（元）",
          num: 0,
          key: "delayAddPrice",
        },
        {
          name: "总预留返佣（元）",
          num: 0,
          key: "storeAddPrice",
        },
        {
          name: "总门店（个）",
          num: 0,
          key: "area",
        },
      ],
      // formItemList: [
      //   {
      //     type: "pickerOptions",
      //     labelName: "",
      //     pickerOptions: {
      //       onPick: ({ maxDate, minDate }) => {
      //         // 选中了开始日期，未选结束日期
      //         if (minDate && !maxDate) {
      //           // 记录开始时间
      //           this.startDate = minDate;
      //         }
      //       },
      //       // 禁用日期函数
      //       disabledDate: (time) => {
      //         // 未选择开始日期时，不限制
      //         if (!this.startDate) return false;

      //         // 允许选择的最大日期 = 开始日期 + 31天
      //         const maxDate = new Date(this.startDate);
      //         maxDate.setDate(maxDate.getDate() + 31);

      //         // 超过 31 天的日期全部禁用
      //         return time > maxDate;
      //       },
      //       // disabledDate(time) {
      //       //   return time.getTime() > postionTime;
      //       // },
      //     },
      //     key: "value3",
      //   },
      // ],
      dateTime: [],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && !maxDate) {
            this.startDate = minDate;
          } else {
            this.startDate = null;
          }
        },
        // 禁用日期函数【时间搜索框最多支持连续1个月的数据】
        disabledDate: (time) => {
          // 1. 禁止选择今天以后的日期
          // if (time.getTime() > postionTime) return true;

          // 2. 已选开始日期，则禁止超过 31 天的日期
          if (this.startDate) {
            const maxAllowDate = new Date(this.startDate);
            const minAllowDate = new Date(this.startDate);
            maxAllowDate.setDate(maxAllowDate.getDate() + 31);
            minAllowDate.setDate(maxAllowDate.getDate() - 31);
            return !(time <= maxAllowDate && time >= minAllowDate);
          }

          return false;
        },
      },
    };
  },
  created() {
    this.dataSearch();
  },
  methods: {
    dataSearch() {
      this.dataLoading = true;
      const resData = {
        areaId: 0,
        companyId: 0,
        endTime: "",
        inspectorId: 0,
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        storeId: 0,
        tagId: 0,
      };

      if (this.dateTime && this.dateTime.length > 0) {
        resData.startTime = moment(this.dateTime[0]).format();
        resData.endTime = moment(this.dateTime[1]).format();
      }

      _http
        .storeCountData(resData)
        .then((res) => {
          if (res.code === 1) {
            const data = res.data;
            for (let i = 0; i < this.listData.length; i++) {
              const item = this.listData[i];
              item.num = data[item.key];
              this.listData.splice(i, 1, item);
            }
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.StaffBox {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 20px 19px 20px;

  &-right {
    display: flex;
    align-items: center;

    .titleTipIcon {
      width: 18px;
      height: 18px;
      margin-left: 10px;
      cursor: pointer;
    }
  }

  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      vertical-align: middle;
    }
  }
  &-data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    > div {
      text-align: center;
      width: 19.0184%;
      max-width: 310px;
      height: 120px;
      border-radius: 10px;
      background-image: url("../../../assets/images/xinyulou/data_bg.png");
      background-size: cover;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .flexCenter {
    .name {
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      color: #081a56;
      line-height: 20px;
    }
    .num {
      font-family: D-DIN-PRO, D-DIN-PRO;
      font-weight: 600;
      font-size: 22px;
      color: #081a56;
      line-height: 26px;
      margin-top: 10px;
    }
  }
}
</style>
